import { render, staticRenderFns } from "./lookup-table-builder.vue?vue&type=template&id=5b48bffe&scoped=true"
import script from "./lookup-table-builder.vue?vue&type=script&lang=js"
export * from "./lookup-table-builder.vue?vue&type=script&lang=js"
import style0 from "./lookup-table-builder.vue?vue&type=style&index=0&id=5b48bffe&prod&lang=css"
import style1 from "./lookup-table-builder.vue?vue&type=style&index=1&id=5b48bffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48bffe",
  null
  
)

export default component.exports